export const countries = [
  {
    alpha2: "AF",
    alpha3: "AFG",
    nameEn: "Afghanistan",
    nameSv: "Afghanistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AL",
    alpha3: "ALB",
    nameEn: "Albania",
    nameSv: "Albanien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DZ",
    alpha3: "DZA",
    nameEn: "Algeria",
    nameSv: "Algeriet",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AD",
    alpha3: "AND",
    nameEn: "Andorra",
    nameSv: "Andorra",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AO",
    alpha3: "AGO",
    nameEn: "Angola",
    nameSv: "Angola",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AG",
    alpha3: "ATG",
    nameEn: "Antigua and Barbuda",
    nameSv: "Antigua och Barbuda",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AR",
    alpha3: "ARG",
    nameEn: "Argentina",
    nameSv: "Argentina",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AM",
    alpha3: "ARM",
    nameEn: "Armenia",
    nameSv: "Armenien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AU",
    alpha3: "AUS",
    nameEn: "Australia",
    nameSv: "Australien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AT",
    alpha3: "AUT",
    nameEn: "Austria",
    nameSv: "Österrike",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AZ",
    alpha3: "AZE",
    nameEn: "Azerbaijan",
    nameSv: "Azerbajdzjan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BS",
    alpha3: "BHS",
    nameEn: "Bahamas",
    nameSv: "Bahamas",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BH",
    alpha3: "BHR",
    nameEn: "Bahrain",
    nameSv: "Bahrain",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BD",
    alpha3: "BGD",
    nameEn: "Bangladesh",
    nameSv: "Bangladesh",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BB",
    alpha3: "BRB",
    nameEn: "Barbados",
    nameSv: "Barbados",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BY",
    alpha3: "BLR",
    nameEn: "Belarus",
    nameSv: "Belarus",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BE",
    alpha3: "BEL",
    nameEn: "Belgium",
    nameSv: "Belgien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BZ",
    alpha3: "BLZ",
    nameEn: "Belize",
    nameSv: "Belize",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BJ",
    alpha3: "BEN",
    nameEn: "Benin",
    nameSv: "Benin",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BT",
    alpha3: "BTN",
    nameEn: "Bhutan",
    nameSv: "Bhutan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BO",
    alpha3: "BOL",
    nameEn: "Bolivia",
    nameSv: "Bolivia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BA",
    alpha3: "BIH",
    nameEn: "Bosnia and Herzegovina",
    nameSv: "Bosnien och Hercegovina",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BW",
    alpha3: "BWA",
    nameEn: "Botswana",
    nameSv: "Botswana",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BR",
    alpha3: "BRA",
    nameEn: "Brazil",
    nameSv: "Brasilien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BN",
    alpha3: "BRN",
    nameEn: "Brunei Darussalam",
    nameSv: "Brunei",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BG",
    alpha3: "BGR",
    nameEn: "Bulgaria",
    nameSv: "Bulgarien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BF",
    alpha3: "BFA",
    nameEn: "Burkina Faso",
    nameSv: "Burkina Faso",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "BI",
    alpha3: "BDI",
    nameEn: "Burundi",
    nameSv: "Burundi",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CV",
    alpha3: "CPV",
    nameEn: "Cabo Verde",
    nameSv: "Kap Verde",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KH",
    alpha3: "KHM",
    nameEn: "Cambodia",
    nameSv: "Kambodja",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CM",
    alpha3: "CMR",
    nameEn: "Cameroon",
    nameSv: "Kamerun",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CA",
    alpha3: "CAN",
    nameEn: "Canada",
    nameSv: "Kanada",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CF",
    alpha3: "CAF",
    nameEn: "Central African Republic",
    nameSv: "Centralafrikanska republiken",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TD",
    alpha3: "TCD",
    nameEn: "Chad",
    nameSv: "Tchad",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CL",
    alpha3: "CHL",
    nameEn: "Chile",
    nameSv: "Chile",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CN",
    alpha3: "CHN",
    nameEn: "China",
    nameSv: "Kina",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CO",
    alpha3: "COL",
    nameEn: "Colombia",
    nameSv: "Colombia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KM",
    alpha3: "COM",
    nameEn: "Comoros",
    nameSv: "Komorerna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CG",
    alpha3: "COG",
    nameEn: "Congo",
    nameSv: "Kongo-Brazzaville",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CD",
    alpha3: "COD",
    nameEn: "Congo, Democratic Republic of the",
    nameSv: "Kongo-Kinshasa",
    riskLevel: "MEDIUM"
},
   {
    alpha2: "CR",
    alpha3: "CRI",
    nameEn: "Costa Rica",
    nameSv: "Costa Rica",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CI",
    alpha3: "CIV",
    nameEn: "Côte d'Ivoire",
    nameSv: "Elfenbenskusten",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "HR",
    alpha3: "HRV",
    nameEn: "Croatia",
    nameSv: "Kroatien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CU",
    alpha3: "CUB",
    nameEn: "Cuba",
    nameSv: "Kuba",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CY",
    alpha3: "CYP",
    nameEn: "Cyprus",
    nameSv: "Cypern",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CZ",
    alpha3: "CZE",
    nameEn: "Czech Republic",
    nameSv: "Tjeckien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DK",
    alpha3: "DNK",
    nameEn: "Denmark",
    nameSv: "Danmark",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DJ",
    alpha3: "DJI",
    nameEn: "Djibouti",
    nameSv: "Djibouti",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DM",
    alpha3: "DMA",
    nameEn: "Dominica",
    nameSv: "Dominica",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DO",
    alpha3: "DOM",
    nameEn: "Dominican Republic",
    nameSv: "Dominikanska republiken",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "EC",
    alpha3: "ECU",
    nameEn: "Ecuador",
    nameSv: "Ecuador",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "EG",
    alpha3: "EGY",
    nameEn: "Egypt",
    nameSv: "Egypten",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SV",
    alpha3: "SLV",
    nameEn: "El Salvador",
    nameSv: "El Salvador",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GQ",
    alpha3: "GNQ",
    nameEn: "Equatorial Guinea",
    nameSv: "Ekvatorialguinea",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ER",
    alpha3: "ERI",
    nameEn: "Eritrea",
    nameSv: "Eritrea",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "EE",
    alpha3: "EST",
    nameEn: "Estonia",
    nameSv: "Estland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SZ",
    alpha3: "SWZ",
    nameEn: "Eswatini",
    nameSv: "Eswatini",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ET",
    alpha3: "ETH",
    nameEn: "Ethiopia",
    nameSv: "Etiopien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "FJ",
    alpha3: "FJI",
    nameEn: "Fiji",
    nameSv: "Fiji",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "FI",
    alpha3: "FIN",
    nameEn: "Finland",
    nameSv: "Finland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "FR",
    alpha3: "FRA",
    nameEn: "France",
    nameSv: "Frankrike",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GA",
    alpha3: "GAB",
    nameEn: "Gabon",
    nameSv: "Gabon",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GM",
    alpha3: "GMB",
    nameEn: "Gambia",
    nameSv: "Gambia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GE",
    alpha3: "GEO",
    nameEn: "Georgia",
    nameSv: "Georgien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "DE",
    alpha3: "DEU",
    nameEn: "Germany",
    nameSv: "Tyskland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GH",
    alpha3: "GHA",
    nameEn: "Ghana",
    nameSv: "Ghana",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GR",
    alpha3: "GRC",
    nameEn: "Greece",
    nameSv: "Grekland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GD",
    alpha3: "GRD",
    nameEn: "Grenada",
    nameSv: "Grenada",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GT",
    alpha3: "GTM",
    nameEn: "Guatemala",
    nameSv: "Guatemala",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GN",
    alpha3: "GIN",
    nameEn: "Guinea",
    nameSv: "Guinea",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GW",
    alpha3: "GNB",
    nameEn: "Guinea-Bissau",
    nameSv: "Guinea-Bissau",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GY",
    alpha3: "GUY",
    nameEn: "Guyana",
    nameSv: "Guyana",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "HT",
    alpha3: "HTI",
    nameEn: "Haiti",
    nameSv: "Haiti",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "HN",
    alpha3: "HND",
    nameEn: "Honduras",
    nameSv: "Honduras",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "HU",
    alpha3: "HUN",
    nameEn: "Hungary",
    nameSv: "Ungern",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "IS",
    alpha3: "ISL",
    nameEn: "Iceland",
    nameSv: "Island",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "IN",
    alpha3: "IND",
    nameEn: "India",
    nameSv: "Indien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ID",
    alpha3: "IDN",
    nameEn: "Indonesia",
    nameSv: "Indonesien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "IR",
    alpha3: "IRN",
    nameEn: "Iran",
    nameSv: "Iran",
    riskLevel: "VERY_HIGH"
},
  {
    alpha2: "IQ",
    alpha3: "IRQ",
    nameEn: "Iraq",
    nameSv: "Irak",
    riskLevel: "VERY_HIGH"
},
  {
    alpha2: "IE",
    alpha3: "IRL",
    nameEn: "Ireland",
    nameSv: "Irland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "IL",
    alpha3: "ISR",
    nameEn: "Israel",
    nameSv: "Israel",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "IT",
    alpha3: "ITA",
    nameEn: "Italy",
    nameSv: "Italien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "JM",
    alpha3: "JAM",
    nameEn: "Jamaica",
    nameSv: "Jamaica",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "JP",
    alpha3: "JPN",
    nameEn: "Japan",
    nameSv: "Japan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "JO",
    alpha3: "JOR",
    nameEn: "Jordan",
    nameSv: "Jordanien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KZ",
    alpha3: "KAZ",
    nameEn: "Kazakhstan",
    nameSv: "Kazakstan",
    riskLevel: "HIGH"
},
  {
    alpha2: "KE",
    alpha3: "KEN",
    nameEn: "Kenya",
    nameSv: "Kenya",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KI",
    alpha3: "KIR",
    nameEn: "Kiribati",
    nameSv: "Kiribati",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KP",
    alpha3: "PRK",
    nameEn: "Korea, Democratic People's Republic of",
    nameSv: "Nordkorea",
    riskLevel: "VERY_HIGH"
},
  {
    alpha2: "KR",
    alpha3: "KOR",
    nameEn: "Korea, Republic of",
    nameSv: "Sydkorea",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KW",
    alpha3: "KWT",
    nameEn: "Kuwait",
    nameSv: "Kuwait",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KG",
    alpha3: "KGZ",
    nameEn: "Kyrgyzstan",
    nameSv: "Kirgizistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LA",
    alpha3: "LAO",
    nameEn: "Lao People's Democratic Republic",
    nameSv: "Laos",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LV",
    alpha3: "LVA",
    nameEn: "Latvia",
    nameSv: "Lettland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LB",
    alpha3: "LBN",
    nameEn: "Lebanon",
    nameSv: "Libanon",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LS",
    alpha3: "LSO",
    nameEn: "Lesotho",
    nameSv: "Lesotho",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LR",
    alpha3: "LBR",
    nameEn: "Liberia",
    nameSv: "Liberia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LY",
    alpha3: "LBY",
    nameEn: "Libya",
    nameSv: "Libyen",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LI",
    alpha3: "LIE",
    nameEn: "Liechtenstein",
    nameSv: "Liechtenstein",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LT",
    alpha3: "LTU",
    nameEn: "Lithuania",
    nameSv: "Litauen",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LU",
    alpha3: "LUX",
    nameEn: "Luxembourg",
    nameSv: "Luxemburg",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MG",
    alpha3: "MDG",
    nameEn: "Madagascar",
    nameSv: "Madagaskar",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MW",
    alpha3: "MWI",
    nameEn: "Malawi",
    nameSv: "Malawi",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MY",
    alpha3: "MYS",
    nameEn: "Malaysia",
    nameSv: "Malaysia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MV",
    alpha3: "MDV",
    nameEn: "Maldives",
    nameSv: "Maldiverna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ML",
    alpha3: "MLI",
    nameEn: "Mali",
    nameSv: "Mali",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MT",
    alpha3: "MLT",
    nameEn: "Malta",
    nameSv: "Malta",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MH",
    alpha3: "MHL",
    nameEn: "Marshall Islands",
    nameSv: "Marshallöarna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MR",
    alpha3: "MRT",
    nameEn: "Mauritania",
    nameSv: "Mauretanien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MU",
    alpha3: "MUS",
    nameEn: "Mauritius",
    nameSv: "Mauritius",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MX",
    alpha3: "MEX",
    nameEn: "Mexico",
    nameSv: "Mexiko",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "FM",
    alpha3: "FSM",
    nameEn: "Micronesia",
    nameSv: "Mikronesien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MD",
    alpha3: "MDA",
    nameEn: "Moldova",
    nameSv: "Moldavien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MC",
    alpha3: "MCO",
    nameEn: "Monaco",
    nameSv: "Monaco",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MN",
    alpha3: "MNG",
    nameEn: "Mongolia",
    nameSv: "Mongoliet",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ME",
    alpha3: "MNE",
    nameEn: "Montenegro",
    nameSv: "Montenegro",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MA",
    alpha3: "MAR",
    nameEn: "Morocco",
    nameSv: "Marocko",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MZ",
    alpha3: "MOZ",
    nameEn: "Mozambique",
    nameSv: "Moçambique",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MM",
    alpha3: "MMR",
    nameEn: "Myanmar",
    nameSv: "Myanmar",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NA",
    alpha3: "NAM",
    nameEn: "Namibia",
    nameSv: "Namibia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NR",
    alpha3: "NRU",
    nameEn: "Nauru",
    nameSv: "Nauru",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NP",
    alpha3: "NPL",
    nameEn: "Nepal",
    nameSv: "Nepal",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NL",
    alpha3: "NLD",
    nameEn: "Netherlands",
    nameSv: "Nederländerna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NZ",
    alpha3: "NZL",
    nameEn: "New Zealand",
    nameSv: "Nya Zeeland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NI",
    alpha3: "NIC",
    nameEn: "Nicaragua",
    nameSv: "Nicaragua",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NE",
    alpha3: "NER",
    nameEn: "Niger",
    nameSv: "Niger",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NG",
    alpha3: "NGA",
    nameEn: "Nigeria",
    nameSv: "Nigeria",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "MK",
    alpha3: "MKD",
    nameEn: "North Macedonia",
    nameSv: "Nordmakedonien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "NO",
    alpha3: "NOR",
    nameEn: "Norway",
    nameSv: "Norge",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "OM",
    alpha3: "OMN",
    nameEn: "Oman",
    nameSv: "Oman",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PK",
    alpha3: "PAK",
    nameEn: "Pakistan",
    nameSv: "Pakistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PW",
    alpha3: "PLW",
    nameEn: "Palau",
    nameSv: "Palau",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PA",
    alpha3: "PAN",
    nameEn: "Panama",
    nameSv: "Panama",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PG",
    alpha3: "PNG",
    nameEn: "Papua New Guinea",
    nameSv: "Papua Nya Guinea",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PY",
    alpha3: "PRY",
    nameEn: "Paraguay",
    nameSv: "Paraguay",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PE",
    alpha3: "PER",
    nameEn: "Peru",
    nameSv: "Peru",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PH",
    alpha3: "PHL",
    nameEn: "Philippines",
    nameSv: "Filippinerna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PL",
    alpha3: "POL",
    nameEn: "Poland",
    nameSv: "Polen",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "PT",
    alpha3: "PRT",
    nameEn: "Portugal",
    nameSv: "Portugal",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "QA",
    alpha3: "QAT",
    nameEn: "Qatar",
    nameSv: "Qatar",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "RO",
    alpha3: "ROU",
    nameEn: "Romania",
    nameSv: "Rumänien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "RU",
    alpha3: "RUS",
    nameEn: "Russian Federation",
    nameSv: "Ryssland",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "RW",
    alpha3: "RWA",
    nameEn: "Rwanda",
    nameSv: "Rwanda",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "KN",
    alpha3: "KNA",
    nameEn: "Saint Kitts and Nevis",
    nameSv: "Saint Kitts och Nevis",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LC",
    alpha3: "LCA",
    nameEn: "Saint Lucia",
    nameSv: "Saint Lucia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "VC",
    alpha3: "VCT",
    nameEn: "Saint Vincent and the Grenadines",
    nameSv: "Saint Vincent och Grenadinerna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "WS",
    alpha3: "WSM",
    nameEn: "Samoa",
    nameSv: "Samoa",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SM",
    alpha3: "SMR",
    nameEn: "San Marino",
    nameSv: "San Marino",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ST",
    alpha3: "STP",
    nameEn: "Sao Tome and Principe",
    nameSv: "São Tomé och Príncipe",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SA",
    alpha3: "SAU",
    nameEn: "Saudi Arabia",
    nameSv: "Saudiarabien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SN",
    alpha3: "SEN",
    nameEn: "Senegal",
    nameSv: "Senegal",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "RS",
    alpha3: "SRB",
    nameEn: "Serbia",
    nameSv: "Serbien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SC",
    alpha3: "SYC",
    nameEn: "Seychelles",
    nameSv: "Seychellerna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SL",
    alpha3: "SLE",
    nameEn: "Sierra Leone",
    nameSv: "Sierra Leone",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SG",
    alpha3: "SGP",
    nameEn: "Singapore",
    nameSv: "Singapore",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SK",
    alpha3: "SVK",
    nameEn: "Slovakia",
    nameSv: "Slovakien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SI",
    alpha3: "SVN",
    nameEn: "Slovenia",
    nameSv: "Slovenien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SB",
    alpha3: "SLB",
    nameEn: "Solomon Islands",
    nameSv: "Salomonöarna",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SO",
    alpha3: "SOM",
    nameEn: "Somalia",
    nameSv: "Somalia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ZA",
    alpha3: "ZAF",
    nameEn: "South Africa",
    nameSv: "Sydafrika",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SS",
    alpha3: "SSD",
    nameEn: "South Sudan",
    nameSv: "Sydsudan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ES",
    alpha3: "ESP",
    nameEn: "Spain",
    nameSv: "Spanien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "LK",
    alpha3: "LKA",
    nameEn: "Sri Lanka",
    nameSv: "Sri Lanka",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SD",
    alpha3: "SDN",
    nameEn: "Sudan",
    nameSv: "Sudan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SR",
    alpha3: "SUR",
    nameEn: "Suriname",
    nameSv: "Surinam",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SE",
    alpha3: "SWE",
    nameEn: "Sweden",
    nameSv: "Sverige",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "CH",
    alpha3: "CHE",
    nameEn: "Switzerland",
    nameSv: "Schweiz",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "SY",
    alpha3: "SYR",
    nameEn: "Syrian Arab Republic",
    nameSv: "Syrien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TJ",
    alpha3: "TJK",
    nameEn: "Tajikistan",
    nameSv: "Tadzjikistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TZ",
    alpha3: "TZA",
    nameEn: "Tanzania",
    nameSv: "Tanzania",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TH",
    alpha3: "THA",
    nameEn: "Thailand",
    nameSv: "Thailand",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TL",
    alpha3: "TLS",
    nameEn: "Timor-Leste",
    nameSv: "Östtimor",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TG",
    alpha3: "TGO",
    nameEn: "Togo",
    nameSv: "Togo",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TO",
    alpha3: "TON",
    nameEn: "Tonga",
    nameSv: "Tonga",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TT",
    alpha3: "TTO",
    nameEn: "Trinidad and Tobago",
    nameSv: "Trinidad och Tobago",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TN",
    alpha3: "TUN",
    nameEn: "Tunisia",
    nameSv: "Tunisien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TR",
    alpha3: "TUR",
    nameEn: "Türkiye",
    nameSv: "Turkiet",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TM",
    alpha3: "TKM",
    nameEn: "Turkmenistan",
    nameSv: "Turkmenistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "TV",
    alpha3: "TUV",
    nameEn: "Tuvalu",
    nameSv: "Tuvalu",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "UG",
    alpha3: "UGA",
    nameEn: "Uganda",
    nameSv: "Uganda",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "UA",
    alpha3: "UKR",
    nameEn: "Ukraine",
    nameSv: "Ukraina",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "AE",
    alpha3: "ARE",
    nameEn: "United Arab Emirates",
    nameSv: "Förenade Arabemiraten",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "GB",
    alpha3: "GBR",
    nameEn: "United Kingdom",
    nameSv: "Storbritannien",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "US",
    alpha3: "USA",
    nameEn: "United States",
    nameSv: "USA",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "UY",
    alpha3: "URY",
    nameEn: "Uruguay",
    nameSv: "Uruguay",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "UZ",
    alpha3: "UZB",
    nameEn: "Uzbekistan",
    nameSv: "Uzbekistan",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "VU",
    alpha3: "VUT",
    nameEn: "Vanuatu",
    nameSv: "Vanuatu",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "VE",
    alpha3: "VEN",
    nameEn: "Venezuela",
    nameSv: "Venezuela",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "VN",
    alpha3: "VNM",
    nameEn: "Viet Nam",
    nameSv: "Vietnam",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "YE",
    alpha3: "YEM",
    nameEn: "Yemen",
    nameSv: "Jemen",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ZM",
    alpha3: "ZMB",
    nameEn: "Zambia",
    nameSv: "Zambia",
    riskLevel: "MEDIUM"
},
  {
    alpha2: "ZW",
    alpha3: "ZWE",
    nameEn: "Zimbabwe",
    nameSv: "Zimbabwe",
    riskLevel: "MEDIUM"
}
];